module.exports = __webpack_public_path__ + "img/AssistantBMO_SS2.a2323eac.png";